module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.code == undefined) ? _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("\n          Planos\n          "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Contrato\n          " + _vm._s(_vm.contractId) + "\n          "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Veículos\n          "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" " + _vm._s(_vm.plate) + "\n          "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Substituição de TAG\n        ")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })], 1)]), _vm._v(" "), (_vm.msgError) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Atenção!")]), _vm._v(" " + _vm._s(_vm.msgError) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.shipmentType == 4 && _vm.activationError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.activationError) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.salesOrder) ? _c('generic-summary', {
    ref: "GenericSummary",
    attrs: {
      "contract": _vm.contract,
      "order": _vm.salesOrder,
      "showAddress": true,
      "addressInit": _vm.addressInit,
      "account": _vm.user,
      "disablePayment": true
    },
    on: {
      "tag-activation-state": _vm.onTagActivationState
    }
  }) : _vm._e(), _vm._v(" "), (_vm.salesOrder && _vm.tagInHandActivated) ? _c('div', {
    staticClass: "tag-success-banner"
  }, [_c('div', {
    staticClass: "tag-success-message"
  }, [_c('svg', {
    attrs: {
      "width": "22",
      "height": "22",
      "viewBox": "0 0 22 22",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 20.1666C16.0627 20.1666 20.1667 16.0626 20.1667 11C20.1667 5.93737 16.0627 1.83331 11 1.83331C5.93743 1.83331 1.83337 5.93737 1.83337 11C1.83337 16.0626 5.93743 20.1666 11 20.1666Z",
      "stroke": "#2E7D32",
      "stroke-width": "1.83333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.25 11L10.0833 12.8334L13.75 9.16669",
      "stroke": "#2E7D32",
      "stroke-width": "1.83333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tagActivationSuccessMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "tag-success-actions"
  }, [_c('button', {
    staticClass: "btn-finish-tag-flow",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.finalizar()
      }
    }
  }, [_vm._v("\n          Finalizar\n          "), _c('svg', {
    attrs: {
      "width": "6",
      "height": "10",
      "viewBox": "0 0 6 10",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.666748 8.66669L4.66675 4.66669L0.666748 0.666687",
      "stroke": "white",
      "stroke-width": "1.33333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.salesOrder && !_vm.tagInHandActivated) ? _c('div', [_c('div', {
    staticClass: "action-buttons-box"
  }, [_c('div', {
    staticClass: "adhesion-footer-nav",
    class: {
      'adhesion-footer-nav--final-mobile': _vm.isMobile
    }
  }, [_c('div', {
    attrs: {
      "id": "btn-container-adhesion-back-cancel"
    }
  }, [_c('button', {
    attrs: {
      "id": "button-cancel-adhesion",
      "type": "button",
      "disabled": _vm.activationSuccess || _vm.tagInHandActivated
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 4L4 12M4 4L12 12",
      "stroke": "#E21C12",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v("\n              Cancelar\n            ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "btn-container-adhesion-advance"
    }
  }, [(!_vm.isMobile && !(_vm.shipmentType == 4 && _vm.activationSuccess)) ? _c('button', {
    attrs: {
      "id": "button-concluir-adhesion",
      "type": "button",
      "disabled": _vm.activationSuccess
    },
    on: {
      "click": function($event) {
        return _vm.startRequest()
      }
    }
  }, [_vm._v("\n              Finalizar\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isMobile && !(_vm.shipmentType == 4 && _vm.activationSuccess)) ? _c('button', {
    attrs: {
      "id": "button-concluir-adhesion-mobile",
      "type": "button",
      "disabled": _vm.activationSuccess
    },
    on: {
      "click": function($event) {
        return _vm.startRequest()
      }
    }
  }, [_vm._v("\n              Finalizar\n              "), _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.00016 10.6673L10.6668 8.00065M10.6668 8.00065L8.00016 5.33398M10.6668 8.00065H5.3335M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065Z",
      "stroke": "#F5F5F5",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]) : _vm._e()])])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('success-page', {
    attrs: {
      "code": _vm.code,
      "type": 'replaceTag',
      "salesOrder": _vm.salesResponse
    }
  }), _vm._v(" "), _c('error-page', {
    attrs: {
      "code": _vm.code,
      "type": 'replaceTag',
      "salesOrder": _vm.salesResponse
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-178605f8!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/replace-tag/replace-tag.vue
// module id = 2052
// module chunks = 1